// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.packsList[data-v-1baaa0dc] .packVersion {\n  font-family: 'Roboto Mono', monospace;\n}\n.packsList[data-v-1baaa0dc] .v-data-table tbody tr.v-data-table__expanded__content {\n  box-shadow: none;\n}\n", ""]);
// Exports
module.exports = exports;
